import { render, staticRenderFns } from "./CommButtonCall.vue?vue&type=template&id=2e5cb2f0&"
import script from "./CommButtonCall.vue?vue&type=script&lang=js&"
export * from "./CommButtonCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports